/**
 * Redirects a user's page by updating window location and removing present page from browser history
 *
 * @param {string} redirectUrl
 */
export const initiateRedirectAsReplace = redirectUrl => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 4000);
  }
};

/**
 * Redirects a user's page by updating window location and preserving browser history
 *
 * @param {string} redirectUrl
 */
export const initiateRedirectAsAssign = redirectUrl => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      window.location.assign(redirectUrl);
    }, 4000);
  }
};

/**
 * Redirects a user's page by opening a new tab
 *
 * @param {string} redirectUrl
 */
export const initiateRedirectInNewTab = (redirectUrl) => {
  if (typeof window !== 'undefined') {
    setTimeout(() => {
      window.open(redirectUrl, '_blank');
    }, 4000);
  }
};